import React from 'react';

const StyleInjector = ({children, className}) => {
    const StyledChildren = () =>
        React.Children.map(children, child =>
            React.cloneElement(child, {
                    className: `${className} ${child.props.className}`
                }
            )
        );

    return <StyledChildren/>;
};

export default StyleInjector;
